import React from 'react'
import CaptainDashboard from './CaptainDashboard'
import { getMyDashboard } from '../../api/captain'

export default function MyCaptainDashboard() {
  const fetchData = React.useCallback(() => getMyDashboard(), [])
  return <CaptainDashboard fetchData={fetchData} />
}
